// FAQ data for Bonus Edilizi 2025 - Aggiornato secondo Legge di Bilancio 2025
const faqBonusInfissi = [
  {
    id: 1,
    title: "Quali sono i Bonus Edilizi disponibili nel 2025?",
    description:
      "Nel 2025 sono disponibili tre principali agevolazioni fiscali per gli interventi edilizi: il Bonus Casa (ristrutturazioni edilizie), l'Ecobonus (riqualificazione energetica) e il Bonus Sicurezza. La novità principale del 2025 è la distinzione tra abitazione principale e seconde case: per l'abitazione principale si mantiene il 50% di detrazione, mentre per le seconde case scende al 36%. La detrazione viene sempre ripartita in 10 rate annuali di pari importo.",
    links: [
      {
        label: "Agenzia delle Entrate - Ristrutturazioni Edilizie",
        url: "https://www.agenziaentrate.gov.it/portale/aree-tematiche/casa/agevolazioni/agevolazioni-per-le-ristrutturazioni-edilizie",
      },
    ],
  },
  {
    id: 2,
    title: "Cosa rientra nel Bonus Casa 2025?",
    description:
      "Il Bonus Casa copre interventi di manutenzione straordinaria, restauro e risanamento conservativo. Per i prodotti FER-AL, rientrano: sostituzione di finestre e serramenti, installazione di porte blindate, montaggio di persiane, avvolgibili e tapparelle, installazione di inferriate e cancelli. Il limite di spesa è di €96.000 per unità immobiliare, con detrazione del 50% per l'abitazione principale (max €48.000 di detrazione) e del 36% per altre unità (max €34.560).",
    links: [
      {
        label: "Guida Ristrutturazioni Edilizie - Agenzia delle Entrate",
        url: "https://www.agenziaentrate.gov.it/portale/documents/d/guest/ristrutturazioni_edilizie_le_agevolazioni_fiscali",
      },
    ],
  },
  {
    id: 3,
    title: "Cos'è l'Ecobonus e quali infissi sono ammessi?",
    description:
      "L'Ecobonus è la detrazione per interventi di riqualificazione energetica. Per accedervi, gli infissi devono rispettare precisi valori di trasmittanza termica (Valore U) che variano in base alla Zona Climatica: Zona A-B (Palermo, Catania) ≤2,60 W/m²K; Zona C (Napoli, Bari) ≤1,75 W/m²K; Zona D (Roma, Firenze) ≤1,67 W/m²K; Zona E (Milano, Torino, Bologna) ≤1,30 W/m²K; Zona F (Zone Alpine) ≤1,00 W/m²K. La detrazione è del 50% con massimale autonomo di €60.000 per gli infissi.",
    links: [
      {
        label: "ENEA - Ecobonus",
        url: "https://www.efficienzaenergetica.enea.it/detrazioni-fiscali/ecobonus.html",
      },
      {
        label: "Agenzia delle Entrate - Riqualificazione Energetica",
        url: "https://www.agenziaentrate.gov.it/portale/aree-tematiche/casa/agevolazioni/agevolazioni-risparmio-energetico",
      },
    ],
  },
  {
    id: 4,
    title: "Cos'è il Bonus Sicurezza 2025?",
    description:
      "Il Bonus Sicurezza copre tutti gli interventi finalizzati a prevenire atti illeciti. Rientrano: porte blindate, grate e inferriate, serrature e spioncini, tapparelle metalliche con bloccaggi, vetri antisfondamento, cancelli e recinzioni, sistemi di allarme e videosorveglianza. Anche qui vale la distinzione: 50% per l'abitazione principale, 36% per le seconde case. Attenzione: il massimale di €96.000 è condiviso con il Bonus Casa.",
    links: [
      {
        label: "Urmet - Bonus Sicurezza",
        url: "https://www.urmet.com/it-it/Professionista/Notizie-ed-Eventi/News/bonus-sicurezza-2025-requisiti",
      },
    ],
  },
  {
    id: 5,
    title: "Come funziona il Bonifico Parlante?",
    description:
      "Il pagamento deve avvenire ESCLUSIVAMENTE tramite bonifico bancario specifico per detrazioni fiscali (bonifico parlante). Deve contenere: 1) Causale con riferimento normativo (es. 'Art. 16-bis DPR 917/86' per Bonus Casa/Sicurezza, oppure 'L. 296/2006' per Ecobonus); 2) Codice fiscale del beneficiario della detrazione; 3) Partita IVA del fornitore. Un bonifico ordinario fa perdere il diritto alla detrazione!",
    links: [
      {
        label: "Agenzia delle Entrate - Modalità di Pagamento",
        url: "https://www.agenziaentrate.gov.it/portale/modalit%25c3%25a0-di-pagamento-e-altri-adempimenti",
      },
    ],
  },
  {
    id: 6,
    title: "Cos'è la Pratica ENEA e quando è obbligatoria?",
    description:
      "Entro 90 giorni dalla fine dei lavori è obbligatorio trasmettere all'ENEA i dati degli interventi che comportano risparmio energetico. Questo include la sostituzione di infissi, finestre e porte. Per l'Ecobonus la mancata trasmissione comporta la perdita del beneficio. Per il Bonus Casa l'omissione espone a sanzioni, ma secondo le interpretazioni recenti non fa perdere la detrazione. Si consiglia sempre l'invio per prudenza.",
    links: [
      {
        label: "Portale ENEA - Detrazioni Fiscali",
        url: "https://detrazionifiscali.enea.it/",
      },
      {
        label: "ENEA - Guida alla compilazione",
        url: "https://www.efficienzaenergetica.enea.it/detrazioni-fiscali.html",
      },
    ],
  },
  {
    id: 7,
    title: "Posso usare sia Ecobonus che Bonus Sicurezza sullo stesso intervento?",
    description:
      "NO. È tassativamente vietato cumulare due bonus sulla stessa spesa. Esempio: una porta blindata con alte prestazioni termiche può accedere o al Bonus Sicurezza (procedura più snella) oppure all'Ecobonus (richiede rispetto dei valori U e pratica ENEA completa), ma non a entrambi. Il consiglio è valutare quale via sia più conveniente: il Bonus Casa/Sicurezza ha meno vincoli burocratici, l'Ecobonus ha massimali autonomi.",
  },
  {
    id: 8,
    title: "Esistono ancora lo Sconto in Fattura e la Cessione del Credito?",
    description:
      "Per i nuovi lavori avviati nel 2025, NON esistono più lo sconto in fattura o la cessione del credito (salvo rari casi residuali legati a progetti presentati prima di febbraio 2023 o zone terremotate). Il contribuente deve pagare l'intero importo e avere sufficiente IRPEF da pagare per assorbire la detrazione nei 10 anni successivi. Se un anno non si hanno tasse da pagare, quella quota annuale va persa.",
  },
  {
    id: 9,
    title: "Perché conviene agire nel 2025?",
    description:
      "Il 2025 potrebbe essere l'ultimo anno con aliquote vantaggiose. Le proiezioni per il 2026-2027 indicano un ulteriore abbassamento: per le seconde case l'aliquota potrebbe scendere al 30%, mentre per le abitazioni principali si discute se il 50% sarà mantenuto. Chi deve sostituire infissi, installare porte blindate o sistemi di sicurezza dovrebbe considerare il 2025 come anno cruciale per bloccare l'aliquota più favorevole.",
  },
  {
    id: 10,
    title: "FER-AL può aiutarmi con le agevolazioni?",
    description:
      "Sì! FER-AL offre assistenza completa per accedere ai Bonus 2025. I nostri servizi includono: consulenza gratuita per identificare l'agevolazione più adatta; sopralluogo e preventivo dettagliato; fornitura di infissi con certificazione di trasmittanza termica conforme; porte blindate certificate; documentazione tecnica completa; supporto per la compilazione della pratica ENEA. Contattateci per una consulenza senza impegno!",
  },
];

export default faqBonusInfissi;
